import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "assign-thermostat-step1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddDeviceToLinkableObject = _resolveComponent("AddDeviceToLinkableObject")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", null, _toDisplayString(_ctx.$t("assignThermo.selectOnlyOneDescription")), 1),
    _createVNode(_component_AddDeviceToLinkableObject, {
      currentDevices: _ctx.currentDevicesThermostats,
      assignableDevices: _ctx.devicesThermostats,
      linkableObject: _ctx.roomObject,
      deleteUnusedDevices: false,
      isSingleDeviceSelection: true,
      isOnlyDeviceSelection: true,
      addToastMessage: _ctx.$t('assignThermo.thermostatAdded'),
      ruleServiceType: _ctx.SlotRuleServiceType.THERMO_THERMO
    }, null, 8, ["currentDevices", "assignableDevices", "linkableObject", "addToastMessage", "ruleServiceType"])
  ]))
}